import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PerfilService } from 'src/app/service/perfil.service';
import { TarjetasService } from 'src/app/service/tarjetas.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-solicitud',
  templateUrl: './solicitud.component.html',
  styleUrls: ['./solicitud.component.scss']
})
export class SolicitudComponent implements OnInit {

  @Input() numCard: number
  @Input() nuevaSolicitud: boolean = false;
  @Output() closeModal = new EventEmitter<boolean>();

  error: any;
  modalError: any = false;
  loading = false;
  errorSolicitud: boolean;
  clasificaciones: any[];
  subclasificacion: any[];
  response: any
  session: any;
  dataRes: any;
  fechNaci: string = '';
  tituloSolicitud: string = 'Generar una solicitud';
  fechaAux = new Date()
  soliciExito: boolean = false;
  soliciExitoBlock: boolean = false;
  modalErrorBlock = ''
  loadingBlock = false;
  dni: string
  paso2: boolean = false;
  confirma: boolean = false;

  solicitudForm = new FormGroup({
    dni: new FormControl({ value: '', disabled: true }),
    nombres: new FormControl({ value: '', disabled: true }),
    apePaterno: new FormControl({ value: '', disabled: true }),
    apeMaterno: new FormControl({ value: '', disabled: true }),
    monto: new FormControl(0),
    direccion: new FormControl({ value: '', disabled: true }),
    tel: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }, Validators.email),
    sexo: new FormControl({ value: '', disabled: true }),
    date: new FormControl('', Validators.required),
    hora: new FormControl('', Validators.required),
    fnaci: new FormControl(),
    desc: new FormControl(),
    clasif: new FormControl(),
    numTarjetExt: new FormControl({ value: '', disabled: true }),
    subClasif: new FormControl()
  })

  descBloqueo: string = ''


  constructor(private tarjetas: TarjetasService, private perfil: PerfilService) {

    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    this.dni = this.session.dpi
    // this.filterClassification()
    // this.filterSubClassification()
  }


  ngOnInit(): void {

  }

  ngOnChanges(simple: { nuevaSolicitud: { currentValue: boolean } }) {
    if (simple.nuevaSolicitud?.currentValue) {
      this.loadPerfil()
    }
  }

  ngDoCheck() {
  }

  sendSolicitud() {
    this.error = false;
    this.modalError = ""
    if (this.solicitudForm.invalid) {
      this.error = true
    } else {
      this.loading = true;
      /*           if (this.tipoClasif == 'REPOS') {
              this.clasif = '00001';
              this.desclas = 'Personalizada';
              this.codSubClass = 'RS001';
            } */
      /*       if (this.tipoClasif == 'BLOLN') {
              this.clasif = this.sesion.bloqueos[this.bloqueo].numero;
              this.desclas = this.sesion.bloqueos[this.bloqueo].nombreBloqueo;
              this.codSubClass = 'BL001'
            } */
      const FormatDate = this.solicitudForm.get('date').value.split('-').join('') + this.solicitudForm.get('hora').value.split(':').join('') + '00';
      if (this.solicitudForm.get('clasif').value == '-1') {
        this.modalError = "Seleccione una clasificaciön"
        this.loading = false
        return
      }
      if (this.solicitudForm.get('subClasif').value == '-1') {
        this.modalError = "Seleccione una subclasificaciön"
        this.loading = false
        return
      }
      const body = {
        codClaseSolicitud: 'RECLA',
        desTipoSolicitud: 'Reclamo',
        codTipoSolicitud: 'RECLA',
        codAplicacion: 'POCAE',
        numEjecutivo: 3,
        nomResponsable: 'usuInternet',
        run: this.dni,
        tipoId: 'EXT',
        nombres: this.solicitudForm.get('nombres').value,
        apePaterno: this.solicitudForm.get('apePaterno').value,
        apeMaterno: this.solicitudForm.get('apeMaterno').value,
        email: this.solicitudForm.get('email').value,
        telefonoMovil: this.solicitudForm.get('tel').value,
        numTarjetaExtOrigen: this.numCard,
        direccion: this.solicitudForm.get('direccion').value,
        codTipoTarjetaOrigen: '',
        fhoIncidente: FormatDate,
        fecNacimiento: this.solicitudForm.get('fnaci').value,
        sexo: this.solicitudForm.get('sexo').value,
        desTipoTarjetaOrigen: 'Normal',
        codClasificacion: this.clasificaciones[this.solicitudForm.get('clasif').value].sCodParametro02,
        desClasificacion: this.clasificaciones[this.solicitudForm.get('clasif').value].sDesLargo01,
        codSubClasificacion: this.subclasificacion[this.solicitudForm.get('subClasif').value].sCodParametro03,
        desSubClasificacion: this.subclasificacion[this.solicitudForm.get('subClasif').value].sDesLargo01,
        montoSolicitado: this.solicitudForm.get('monto').value,
        glosaDescripcion: this.solicitudForm.get('desc').value,
        desEstado: this.solicitudForm.get('desc').value
      }
      this.tarjetas.sendData(body).subscribe(res => {
        this.response = res;

        if (this.response.nNumError != 0) {
          this.loading = false;
          this.modalError = this.response.sMsjError
        } else {
          this.paso2 = false;
          this.solicitudForm.reset()
          this.soliciExito = true;
          this.loading = false;
        }
      })
    }
  }

  next(response, tipo, titulo) {
    this.errorSolicitud = false;
    this.modalError = false
    this.solicitudForm.get('numTarjetExt').setValue(this.numCard)

    const subject = 'CN=OP.152, OU=transporte, O=sonda, L=santiago, ST=santiago, C=CL ;OU=transporte, O=sonda, L=santiago, ST=santiago, CN=AP.3, C=CL';

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Client-Subject': subject // o subjectBase64
    });

    let date = new Date()
    let dateFormat = `${("0" + date.getDay()).slice(-2)}/${("0" + date.getMonth()).slice(-2)}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    if (tipo == 'BLOLN') {
      this.loadingBlock = true
      this.modalErrorBlock = ''
      // let body = {

      //   "tipoMA": "TAG",
      //   "accion": "BLOQUEO",
      //   "fechaAccion": dateFormat,
      //   "idAplicativo": 7,
      //   "operadorApp": 156,
      //   "codMotivo": 0,
      //   "motivo": this.descBloqueo,
      //   "idma": localStorage.getItem('numInt')

      // }
      this.session.nIdEmpresa =5;
      const body = {
        sesion: {
            sIdSesion: localStorage.getItem("KSI"),
            nIdUsuarioWeb: this.session.idUsuario,
            nIdEmpresa: 5,
            sHost: "127.0.0.1"
          },
          usuario: this.session,
          codtiposolicitud: 'BLOQU',
          destiposolicitud: 'Bloqueo',
          codclasesolicitud: '',
          desclasesolicitud: '',
          codclasificacion: '',
          desclasificacion: '',
          codsubclasificacion: '',
          dessubclasificacion: '',
          numdistribuidor: 0,
          nomdistribuidor: '',
          codoficinaorigen: '',
          nomoficinaorigen: '',
          fhoincidente: '',
          glosadescripcion: '',
          glosaresolucion: '',
          idMAOrigen: '',
          tarjetaExternaOrigen: this.numCard, /// ENVIAR NUMEXTERNO
          idMADestino: '',
          tarjetaInternaDestino: '',
          tarjetaExternaDestino: '',
          saldoDestino: 0,
          codestado: '',
          desestado: '',
          montosolicitado: 0,
          montodevolucion: 0,
          montosolicitud: 0,
          tipomtosolicitud: '',
          codtipotarjetaorigen: '',
          destipotarjetaorigen: '',
          codoperador: 156,
          desoperador: '',
          codmotivo: '',
          desmotivo: '',
          sistematransporte: '',
          dni: this.dni,
          nombres: this.solicitudForm.get('nombres').value,
          apellidoPaterno: this.solicitudForm.get('apePaterno').value,
          apellidoMaterno: this.solicitudForm.get('apeMaterno').value,
          fechaNacimiento: '',
          desTipousuario: '',
          codigoTipoUsuario: '',
          sexo:this.solicitudForm.get('sexo').value,
          direccion: '',
          email: this.solicitudForm.get('email').value,
          codcomuna: '',
          descomuna: '',
          codregion: '',
          desregion: '',
          celular: this.solicitudForm.get('tel').value,
          nidempresa: 0,
          fechaCreacionDesde: '',
          fechaCreacionHasta: '',
          idAccion: 0,
          idProceso: 0,
          nombreCompleto: '',
          numEjeResolucion: 0,
          nomEjeResolucion: '',
          numHostOrigen: 0,
          idPos: '',
          amId: '',
          horaIncidente: '',
          idAplicativo: 7,
          tarjetaInterna: '',
      };

      this.tarjetas.bloqCard(body, { headers }).subscribe(
        res => {

          if (res?.estado?.numeroError == 0) {
            this.soliciExitoBlock = true;
            this.confirma = false;
            this.loadingBlock = false;

            let body = {
              numEjecutivo: 3,
              run: this.dni,
              nombres: this.solicitudForm.get('nombres').value,
              apePaterno: this.solicitudForm.get('apePaterno').value,
              apeMaterno: this.solicitudForm.get('apeMaterno').value,
              email: this.solicitudForm.get('email').value,
              numTarjetaExtOrigen: this.numCard,
              nomResponsable: 'usuInternet',
              telefonoMovil: this.solicitudForm.get('tel').value,
              sexo: this.solicitudForm.get('sexo').value,
              fecNacimiento: this.solicitudForm.get('fnaci').value,
              glosaDescripcion: this.descBloqueo,
              usuario: this.session.usuario,
              nIdEmpresa: 5,
            }

            const mensajeExito = res?.estado?.mensajeError || 'Solicitud de bloqueo enviada correctamente.';
            this.modalErrorBlock = mensajeExito; 
            
          } else {
            this.loadingBlock = false;
            this.modalErrorBlock = res?.estado?.mensajeError
          }
        }

      )
    } else {
      this.paso2 = response
      let json = {
        codTipoSolicitud: tipo,
        dni: this.dni,
        numTarjetaExtOrigen: this.numCard
      }
    }

  }
  // filterClassification() {
  //   // this.tarjetas.cargaParametrosSol().subscribe(res => {
  //   //   this.clasificaciones = res
  //   //   this.clasificaciones = this.clasificaciones.filter((cod) => {
  //   //     return cod.nNumParametro === 13075
  //   //   })
  //   // })
  // }
  // filterSubClassification() {
  //   // this.tarjetas.cargaParametrosSol().subscribe(res => {
  //   //   this.subclasificacion = res
  //   //   this.subclasificacion = this.subclasificacion.filter((cod) => {
  //   //     return cod.nNumParametro === 13076
  //   //   })
  //   // })
  // }


  solicitud(response: boolean) {
    this.error = false;
    this.errorSolicitud = false;
    this.loading = false
    this.nuevaSolicitud = response
    this.modalError = '';
    this.solicitudForm.reset();

    this.closeModal.emit(response)
    if (!response) {
      this.paso2 = false
      this.soliciExito = false;
      this.soliciExitoBlock = false
    }
  }
  loadPerfil() {
    const json = {
    sesion: {
      sIdSesion: this.session.ksi,
      nIdUsuarioWeb: this.session.idUsuario,
      nIdEmpresa: 5,
      sHost: '127.0.0.1'
    },
    nIdUsuarioWeb: this.session.idUsuario,
  };
    this.perfil.loadUser(json).subscribe(res => {
      this.response = res.usuario;

      this.solicitudForm.setValue({
        dni: this.response.sDni,
        nombres: this.response.sNombres,
        apePaterno: this.response.sApellidoMaterno,
        apeMaterno: this.response.sApellidoPaterno,
        monto: 0,
        direccion: this.response.sDireccion,
        sexo: this.response.sSexo,
        fnaci: this.response.sFechaNacimiento,//`${this.response.fecNacimiento.year}${("0" + this.response.fecNacimiento.month.slice(-2))}${("0" + this.response.fecNacimiento.day.slice(-2))}`,
        desc: '',
        date: '',
        hora: '',
        clasif: '-1',
        subClasif: '-1',
        numTarjetExt: this.numCard,
        tel: this.response.sTelefono,
        email: this.response.sCorreo,
      })

    })
  }

  onlyLetter(event) {
    let especiales = [225, 233, 237, 243, 250, 193, 201, 205, 211, 218, 228, 235, 239, 246, 252, 196, 203, 207, 214, 220]
    if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || especiales.includes(event.keyCode)) {
      return true
    }
    else {
      return false
    }
  }

  confirmar($event) {
    this.confirma = $event
    this.modalErrorBlock = '';
    this.descBloqueo = '';
    this.soliciExitoBlock = false;
  }

  cerrar() {
    this.solicitud(true)
    this.nuevaSolicitud = true;
    this.confirma = false
  }

  onlyNumber($event) {
    let key = $event.charCode;
    if (key <= 57 && key >= 48) {
      return true;
    } else {
      return false
    }
  }

  // Cédula panameña: letras, números y guion, sin formatear automáticamente.
  // Se deja tal cual lo escribe el usuario; el backend valida el formato final.
  onlyDniChars(event: any) {
    const pattern = /[^A-Za-z0-9-]/g;
    const cleaned = (event.target.value || '').replace(pattern, '');
    event.target.value = cleaned;
    this.solicitudForm.get('dni').setValue(cleaned, { emitEvent: false });
  }
}
